export default __webpack_public_path__ + "static/media/declaration.5da0a616.png";